import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from './store'
import DefaultLayout from "./layout/DefaultLayout";
import AuthLayout from "./layout/AuthLayout";
Vue.component("defaultlayout", DefaultLayout);
Vue.component("loginlayout", AuthLayout);
import '@progress/kendo-ui'
import { TreeViewInstaller } from '@progress/kendo-treeview-vue-wrapper';

// kendo native 
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { NumericTextBox, Input } from '@progress/kendo-vue-inputs';

Vue.component('k-input', Input);
Vue.component('numerictextbox', NumericTextBox);
Vue.component("grid-toolbar", GridToolbar);
Vue.component("grid-norecords", GridNoRecords);
Vue.component("Grid", Grid);

// kendo wraper
import { ValidatorInstaller } from "@progress/kendo-validator-vue-wrapper";
Vue.use(ValidatorInstaller);
import { LayoutInstaller } from '@progress/kendo-layout-vue-wrapper';
Vue.use(LayoutInstaller)
import { DropDownTree, DropDownTreeInstaller } from '@progress/kendo-dropdowntree-vue-wrapper'
Vue.use(DropDownTreeInstaller)
import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper'
Vue.use(DropdownsInstaller)
import { PopupsInstaller } from '@progress/kendo-popups-vue-wrapper'
Vue.use(PopupsInstaller)
import { InputsInstaller } from "@progress/kendo-inputs-vue-wrapper";
import { DialogInstaller } from "@progress/kendo-dialog-vue-wrapper";
Vue.use(InputsInstaller);
Vue.use(DialogInstaller);
import { RadioGroup } from '@progress/kendo-vue-inputs';

/* Bootstrap specific */
import { IconsPlugin, BTable, BPagination } from 'bootstrap-vue'
import { BFormCheckbox, BFormCheckboxGroup, BFormGroup } from 'bootstrap-vue'
import { BNavItemDropdown } from 'bootstrap-vue'
import { BDropdownItem } from 'bootstrap-vue'
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { WindowInstaller } from '@progress/kendo-window-vue-wrapper';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.component('dropdownlist', DropDownList);
Vue.use(IconsPlugin)
Vue.component('b-nav-item-dropdown', BNavItemDropdown)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-form-checkbox-group', BFormCheckboxGroup)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-dropdown-item', BDropdownItem)
Vue.component('b-table', BTable)
Vue.component('b-pagination', BPagination)

import { ButtonsInstaller } from '@progress/kendo-buttons-vue-wrapper';
Vue.use(ButtonsInstaller);
Vue.use(WindowInstaller);
Vue.component("Grid", Grid);
Vue.use(TreeViewInstaller);
Vue.config.productionTip = false
import "@/assets/scss/index.scss";

/* OIDC Store */
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from '@/config/oidc'


const getApplicationSettings = async () => {
  let settingUrl = window.origin + '/settings.dev.json';
  if (process.env.NODE_ENV == "development") {
    return await (await fetch(settingUrl)).json();
  }
  else if(process.env.NODE_ENV == "staging") {
    return await (await fetch('settings.stag.json')).json();
  }
  // else if (process.env.NODE_ENV == "production") {
  //   return await (await fetch('settings.prod.json')).json();
  // }
  
  else {
    return await (await fetch(settingUrl)).json();
  }

}
getApplicationSettings().then(async (settings) => {
  // Prefetch Application Settings and Set to State
  await store.commit('setSettings', settings);
  //Register the oidc module 
  const settingsOidc = settings.oidc;
  settingsOidc.extraQueryParams = {}
  settingsOidc.extraQueryParams.host = window.origin.split(".")[0];
  settingsOidc.client_id = oidcSettings.clientId 
  settingsOidc.client_secret = oidcSettings.client_secret
  settingsOidc.scope = oidcSettings.scope
  settingsOidc.responseType = oidcSettings.responseType
  settingsOidc.grantType = oidcSettings.grantType
  settingsOidc.prompt = oidcSettings.prompt
  // settingsOidc.acr_values ="tenant:"+window.location.hostname.split(".")[0];
  await store.registerModule('oidcStore', vuexOidcCreateStoreModule(settingsOidc, { namespaced: true }))

  //Start the application
  new Vue({
    store,
    router,
    render: h => h(App),
    components: {
      DropDownTree,
      RadioGroup
    }
  }).$mount('#app')
})

